import { Injectable } from '@angular/core'
import { Store, Action } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { SelectedProfileState } from './selected-profile.reducer'
import * as SelectedProfileSelectors from './selected-profile.selectors'

@Injectable({
  providedIn: 'root',
})
export class SelectedProfileFacade implements GbBaseFacade {
  loaded$ = this.store.select(SelectedProfileSelectors.getSelectedProfileLoaded)
  selectedProfile$ = this.store.select(SelectedProfileSelectors.getSelectedProfile)
  selectedProfileId$ = this.store.select(SelectedProfileSelectors.getSelectedProfileId)
  selectedProfileFirstName$ = this.store.select(SelectedProfileSelectors.getSelectedProfileFirstName)
  selectedProfileStripeCustomer$ = this.store.select(SelectedProfileSelectors.getSelectedProfileStripeCustomer)
  selectedProfileUser$ = this.store.select(SelectedProfileSelectors.getSelectedProfileUser)
  selectedProfileCreditCardRequired$ = this.store.select(SelectedProfileSelectors.getSelectedProfileCreditCardRequired)
  allCustomValues$ = this.store.select(SelectedProfileSelectors.getSelectedProfileCustomValues)

  constructor(private store: Store<SelectedProfileState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
